import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import {
  PaymentApi,
  STAGE_MSE_PRO_MONTHLY,
  STAGE_MSE_PRO_YEARLY,
  US_MSE_PRO_MONTHLY,
  US_MSE_PRO_YEARLY,
  EU_MSE_PRO_MONTHLY,
  EU_MSE_PRO_YEARLY,
} from '@/domains/payment';
import { ref } from 'vue';

import { REGION } from '@eureka/utils/environment';
import { DeployEnv } from '@patsnap-utils/biz';
import { Toast } from 'patsnap-biz';
import { useTracking } from '../tracking/use-tracking';

const defaultSuccessUrl = `${window.location.origin}/mse/#/home/success-payment`;
const defaultCancelUrl = `${window.location.origin}/mse/#/home/`;

const { sendTracking } = useTracking();

export const useHandlePro = () => {
  const paymentApi = injectService<PaymentApi>(PaymentApi);
  const isPaymentLoading = ref(false);
  const isError = ref(false);

  const handlePriceIdSelection = async (priceId: string) => {
    isPaymentLoading.value = true;

    sendTracking('SS EUREKA UPGRADE PAGE', 'click_subscribe_pro', {
      product_line: 'eureka_mse',
    });

    const res = await paymentApi.createPaymentSession({
      price_ids: [priceId],
      mode: 'subscription',
      ui_mode: 'hosted',
      success_url: defaultSuccessUrl,
      cancel_url: defaultCancelUrl,
      automatic_tax: true,
    });
    if (!res?.url) {
      Toast({
        message: 'Failed to create payment session. Please try again.',
        type: 'error',
      });
      isError.value = true;
      return;
    }
    window.location.href = res.url;
    isPaymentLoading.value = false;
  };

  const handleSelectPro = async (period: 'MONTHLY' | 'YEARLY') => {
    let priceId = '';

    if (REGION === DeployEnv.STAGE) {
      priceId = period === 'MONTHLY' ? STAGE_MSE_PRO_MONTHLY : STAGE_MSE_PRO_YEARLY;
    } else if (REGION === DeployEnv.US) {
      priceId = period === 'MONTHLY' ? US_MSE_PRO_MONTHLY : US_MSE_PRO_YEARLY;
    } else if (REGION === DeployEnv.EU) {
      priceId = period === 'MONTHLY' ? EU_MSE_PRO_MONTHLY : EU_MSE_PRO_YEARLY;
    }

    await handlePriceIdSelection(priceId);
  };

  return {
    isError,
    isPaymentLoading,
    handleSelectPro,
    handlePriceIdSelection,
  };
};
